module.exports = __webpack_public_path__ + "static/media/hr_effective.d82e1dd1.jpeg";